export const SET_COMMENT_LIST =  "setCommentList"
export const SET_USER_TAG =  "setUserTag"
export const SET_USER_INFO =  "setUserInfo"
export const SET_LOGIN_MESSAGE = 'setLoginMessage'
export const GET_USER_INFO =  "getUserInfo"
export const SET_LOGIN_STATE =  "setLoginState"
export const GET_LOGIN_STATE =  "getLoginState"

export const SET_WEB_CONFIG_DATA =  "setWebConfigData"

export const INCREMENT =  "increment"
export const DECREMENT =  "decrement"



// WEBPACK FOOTER //
// ./src/store/mutation-types.js